import { filter } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { InboxSortService, WorkqueueService, UserInfoService, IntimationService, ClaimRegistrationService } from '../../../../BaseFramework/core/http';
import * as moment from 'moment/moment';
import { MetadataService } from '../../../../BaseFramework/core/http/metadata.service';
import { json } from 'ngx-custom-validators/src/app/json/validator';
import {
  InteractService, AppMetadataHandler, CommonUtilty
} from 'app'
import { Router, ActivatedRoute } from '@angular/router';
import { ArrayManipulations } from 'app/BaseFramework/core/utilities/arrayManipulations';
import { of } from 'rxjs';
import { environment } from 'environments/environment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';

class SearchAPIMetaDataDO {
  key: any;
  keyDescription: any;
  valueInputType: any;
  lookupName: any;
  lookup: any;
  enable: true;
  isMandatory: Boolean;
}

class WorkQueTreeDO {
  icon: any;
  title: any;
  key: any;
  expanded: Boolean;
  parentQueueCd: any;
  isLeaf: Boolean;
  count: any;
  children: any = [];
}
class InboxAttributeDO {
  key: any;
  value: any;
  description: any;
  isVisible: Boolean;
}

@Component({
  selector: 'app-workbench',
  templateUrl: './workbench.component.html',
  styleUrls: ['./workbench.component.scss']
})
export class WorkbenchComponent implements OnInit {
  public searchResultList = []
  public workQueueAPIResponse: any[] = null;
  public fakeLoadingCards = [1, 2, 3]
  public CRITERIALOOKUP = [];
  public sortCriteria: any = '';
  public _subscription: any;
  public MetaDataMapdummy: any
  public _inboxType: any = null
  public env = environment



  modShowReassing: boolean = false;

  constructor(private workQueueService: WorkqueueService,
    private inboxSortService: InboxSortService,
    private metadataService: MetadataService,
    private userInfoService: UserInfoService,
    private intimationService: IntimationService,
    private interactService: InteractService,
    private claimRegistrationService: ClaimRegistrationService,
    private router: Router,
    public appMetadataHandler: AppMetadataHandler,
    private activatedRoute: ActivatedRoute,
    private notification: NzNotificationService,
    private commonUtilty: CommonUtilty,
    private arrayManipulations: ArrayManipulations,
    private message: NzMessageService
  ) { }

  ngOnInit() {

    this.activatedRoute.data.subscribe(data => {
      this._inboxType = data['inboxType']
      this.inboxFullPrivilege = !!!(this._inboxType == 'partner-inbox')

    });
    this.randomizeList();
    this.loadCases('myCases');
    this.metadataService.getSearchCriteriaList('searchInbox').subscribe(resp => {
      this.CRITERIALOOKUP = this.commonUtilty.deepCopy(resp)
    });
    this.sortCriteria = this.inboxSortService.sortCondition;
    let me = this
    this._subscription = this.inboxSortService.sortConditionChange.subscribe((value) => {
      me.sortCriteria = value;
    })

    this.setInboxCardMetaData()
    this.refreshReassingTaskList();
  }

  setInboxCardMetaData() {
    this.MetaDataMapdummy = this.appMetadataHandler.inboxCardMetaData.default
    this.filteredMetaDataMap = Object.assign([], this.MetaDataMapdummy).filter(
      item => item.isVisible == true
    )
  }


  optionTEMP = 0;
  isLoading = false;
  inboxViewName = null;
  radioValue = 'myCases';
  workques = [];
  filteredMetaDataMap = [];
  randomizeList = function () {
    this.loadFaker();
    // this.list = this.list.sort(() => Math.random() - 0.5);
  };

  lookupsToBind = ['roleUsers']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  loadFaker = function () {
    this.isLoading = true;
    setTimeout(() => { this.isLoading = false }, 1250);
  };

  inboxFullPrivilege = true

  fetchSearchResult($event) {
    this.searchResultList = $event
    this.workQueueAPIResponse = this.searchResultList || [];
    this.workQueueAPIResponse = this.workQueueService.setSLA(this.workQueueAPIResponse) || [];

    this.setTaskCountForFolder()
    this.stopListLoader();
    this.resetPageNumber();
  }

  private resetPageNumber() {
    this.pageNumber = 1;
  }

  loadCases(section: String) {
    this.resetPageNumber();
    this.startListLoader()
    console.log(section);
    if ('teamCases' == section) {
      this.inboxViewName = 'TEAMLEADTASK'
      this.getUserTeammateTasks();
    }
    else if ('subCases' == section) {
      this.inboxViewName = 'WORKQUEUEMANAGER'
      this.getUserSubordinateTasks();
    }
    else {
      this.inboxViewName = 'INDIVIDUAL'
      this.getIndivisualTasks();
    }
  }
  openTransactionDetails(objectData) {
    let entityGuid = objectData.componentData.entityGuid;
    let serviceTask = objectData.componentData.serviceTask;
    let taskId = objectData.componentData.taskId;
    let transactionDataIO: any = [];
    if (serviceTask == "claimIntimation") {
      transactionDataIO = this.fetchIntimationAndPassItToTransaction(entityGuid, transactionDataIO, serviceTask, taskId);
    } else if (serviceTask == "claimRegistration" ||
      serviceTask == "claimAdjudication" ||
      serviceTask == "claimUWReferral" ||
      serviceTask == "claimReinsReferral" ||
      serviceTask == "claimInvestigation" ||
      serviceTask == "claimHOReferralWaiver" ||
      serviceTask == "claimHOReferralOpinion" ||
      serviceTask == "claimsCommitteeReferral") {
      transactionDataIO = this.fetchClaimAndPassItToTransaction(entityGuid, transactionDataIO, serviceTask, taskId);
    }
  }
  private fetchIntimationAndPassItToTransaction(entityGuid: any, transactionDataIO: any, serviceTask: any, taskId: any) {
    this.intimationService.getIntimationByGuid(entityGuid).
      subscribe(resp => {
        transactionDataIO = resp;
        let inboxType = this._inboxType
        this.interactService.sendIOToTransaction(serviceTask, transactionDataIO, taskId, null, inboxType);
        this.router.navigate(['/app/claims/transaction/details'], { queryParams: {}, replaceUrl: false });
      });
    return transactionDataIO;
  }

  private fetchClaimAndPassItToTransaction(entityGuid: any, transactionDataIO: any, serviceTask: any, taskId: any) {
    this.claimRegistrationService.getClaimDataByGuid(entityGuid).
      subscribe(resp => {
        transactionDataIO = resp;
        let inboxType = this._inboxType
        this.interactService.sendIOToTransaction(serviceTask, transactionDataIO, taskId, null, inboxType);
        this.router.navigate(['/app/claims/transaction/details'], { queryParams: {}, replaceUrl: false });
      });
    return transactionDataIO;
  }

  treeClick(data: any) {
    this.resetPageNumber();
    if (data && data.node && data.node.isLeaf) {
      if (this.inboxViewName == 'TEAMLEADTASK') {
        if (data.keys && data.keys.length > 0)
          var me = this;
        this.workQueueService.getTaskList(data.keys[0])
          .subscribe(jsonResp => {
            if (jsonResp) {
              this.workQueueAPIResponse = jsonResp || [];
              this.workQueueAPIResponse = this.workQueueService.setSLA(this.workQueueAPIResponse) || [];
              this.setServerDateToUIDateFormat();
              this.stopListLoader();
            }
          })
      } else if (this.inboxViewName == 'INDIVIDUAL') {
        this.getFolderData(data.keys[0])
      } else if (this.inboxViewName == 'WORKQUEUEMANAGER') {
        this.getFolderData(data.keys[0])
      }
    }
    else {
      this.message.warning("Click on a folder to view cases.", { nzDuration: 1000 })
    }
  }

  nodes = [];
  nodes_Cases = [];

  startListLoader() {
    this.isLoading = true;
  };

  stopListLoader() {
    this.isLoading = false
  }

  getIndivisualTasks() {
    let userId = null
    userId = this.userInfoService.getUserId();
    var me = this;
    this.workQueueService.getTaskList(userId)
      .subscribe(jsonResp => {
        if (jsonResp) {
          this.workQueueAPIResponse = jsonResp || [];
          this.workQueueAPIResponse = this.workQueueService.setSLA(this.workQueueAPIResponse) || [];
          this.setServerDateToUIDateFormat()

          this.getWorkQueData();
        }
        this.stopListLoader();
      })
  }
  getUserSubordinateTasks() {
    this.workQueueService.getSubordinateTasks()
      .subscribe(jsonResp => {
        if (jsonResp) {
          this.workQueueAPIResponse = jsonResp || [];
          this.workQueueAPIResponse = this.workQueueService.setSLA(this.workQueueAPIResponse) || [];
          this.setServerDateToUIDateFormat()

          this.getWorkQueueDataByMAnagerId()
          this.stopListLoader()
        }
      })
  }
  getUserTeammateTasks() {
    this.workQueueService.getTeammateTasks()
      .subscribe(jsonResp => {
        if (jsonResp) {
          this.workQueueAPIResponse = jsonResp || [];
          this.workQueueAPIResponse = this.workQueueService.setSLA(this.workQueueAPIResponse) || [];
          this.setServerDateToUIDateFormat()
          this.getReportedUsers();
          this.stopListLoader()
        }
      })
  }
  getWorkQueData() {
    this.nodes_Cases = []
    if (!this.inboxFullPrivilege) {
      this.workQueueService.getWorkQueues().subscribe(Response => {
        if (Response) {
          this.workques = Response;
          this.setTaskCountForFolder()
        }
      }, errResponse => { })
    }
    else {
      this.workQueueService.getAllWorkQueues().subscribe(Response => {
        if (Response) {
          this.workques = Response;
          this.setTaskCountForFolder()
        }
      }, errResponse => { })
    }
  }
  getWorkQueueDataByMAnagerId() {
    this.nodes_Cases = []
    this.workQueueService.getWorkQueuesByManagerId().subscribe(Response => {
      if (Response) {
        this.workques = Response;
        this.setTaskCountForFolder()
      }
    }, errResponse => { })
  }

  setTaskCountForFolder() {
    this.nodes = []
    this.nodes_Cases = []

    let workques
    if (Array.isArray(this.workques))
      workques = this.workques.filter(function (e) { return e != null });
    if (workques && workques.length > 0) {
      workques.forEach(workque => {
        if (workque != undefined && workque != null) {
          var count = 0;
          if (this.workQueueAPIResponse)
            this.workQueueAPIResponse.forEach(element => {
              count += element.workQueue == workque.queueCd ? 1 : 0
            });
          workque.taskCount = count;
        }
      });
    }
    if (workques && workques.length > 0) {
      for (var i = 0; i < workques.length; i++) {
        if (workques[i] != undefined && workques[i] != null && workques[i].parentQueueCd === null) {
          let workQueTreeDO = new WorkQueTreeDO();
          workQueTreeDO.key = workques[i].queueCd;
          //   workQueTreeDO.icon = workques[i].icon; //"anticon anticon-user";
          workQueTreeDO.expanded = true;
          workQueTreeDO.title = workques[i].queueDesc;
          workQueTreeDO.parentQueueCd = workques[i].parentQueueCd;
          this.nodes_Cases.push(workQueTreeDO)
        }
      }
    }
    if (workques && workques.length > 0) {
      for (var i = 0; i < workques.length; i++) {
        let isLeafFl = this.checkNodeIsLeaf(workques, i, workques[i].queueCd);
        for (var j = 0; j < this.nodes_Cases.length; j++) {
          if (workques[i] != undefined && workques[i] != null) {
            if (workques[i].parentQueueCd == this.nodes_Cases[j].key) {
              let workQueTreeDO = new WorkQueTreeDO();
              workQueTreeDO.key = workques[i].queueCd;
              if (isLeafFl)
                workQueTreeDO.icon = workques[i].icon;
              workQueTreeDO.isLeaf = isLeafFl;
              workQueTreeDO.count = workques[i].taskCount
              workQueTreeDO.title = workques[i].queueDesc // + ' (' + workques[i].taskCount + ')';
              this.nodes_Cases[j].children.push(workQueTreeDO);
            }
          }
          for (var k = 0; k < this.nodes_Cases[j].children.length; k++) {
            if (workques[i] != undefined && workques[i] != null) {
              if (workques[i].parentQueueCd == this.nodes_Cases[j].children[k].key) {
                let workQueTreeDO = new WorkQueTreeDO();
                workQueTreeDO.key = workques[i].queueCd;
                if (isLeafFl)
                  workQueTreeDO.icon = workques[i].icon;

                workQueTreeDO.isLeaf = isLeafFl;
                workQueTreeDO.count = workques[i].taskCount
                workQueTreeDO.title = workques[i].queueDesc //+ ' (' + workques[i].taskCount + ')';
                this.nodes_Cases[j].children[k].children.push(workQueTreeDO);
              }
            }
          }
        }
      }
    }
    console.log('Nodes', this.nodes_Cases)
    this.nodes = this.workQueueService.applyCountToParentNode(this.nodes_Cases, this.workQueueAPIResponse);
  }



  checkNodeIsLeaf(workques, index, queueCd) {
    for (var i = 0; i < workques.length; i++) {
      if (i != index) {
        if (workques[i] != undefined && workques[i] != null) {
          if (workques[i].parentQueueCd != null && workques[i].parentQueueCd != undefined && queueCd) {
            if (queueCd == workques[i].parentQueueCd) {
              return false;
            }
          }
        }
      }
    }
    return true;
  }

  pageNumber = 1
  itemsPerPage = 10
  totalitems
  getPageWiseInboxItems(workQueue?) {
    let queue = workQueue || this.workQueueAPIResponse
    if (queue && Array.isArray(queue) && this.appMetadataHandler.featureFlags.enablePaginationOnInbox) {
      this.totalitems = queue.length
      let _chunks = this.arrayManipulations.chunkArray(queue, this.itemsPerPage)
      let pageToArrayIndex = this.pageNumber - 1
      return of(_chunks[pageToArrayIndex])
    }
    else if (!this.appMetadataHandler.featureFlags.enablePaginationOnInbox) {
      return of(queue)
    }
  }

  setCurrentPageNumber(currentPageNum) {
    this.isLoading = true
    this.pageNumber = currentPageNum
    setTimeout(() => {
      this.isLoading = false
    }, 100);

  }

  getReportedUsers() {
    var me = this;
    this.nodes_Cases = []
    this.workQueueService.getReportedUsers()
      .subscribe(jsonResp => {
        if (jsonResp) {
          let teamusers = jsonResp;
          if (teamusers && teamusers.length > 0) {
            teamusers.forEach(teamuser => {
              var count = 0;
              if (this.workQueueAPIResponse)
                this.workQueueAPIResponse.forEach(element => {
                  count += element.taskUser == teamuser.userId ? 1 : 0
                });
              teamuser.taskCount = count;
            })
          }
          if (teamusers.length > 0) {
            for (let i = 0; i < teamusers.length; i++) {
              let workQueTreeDO = new WorkQueTreeDO();
              workQueTreeDO.key = teamusers[i].userId;
              workQueTreeDO.icon = 'anticon anticon-user';
              workQueTreeDO.isLeaf = true;
              workQueTreeDO.title = teamusers[i].firstName + " (" + teamusers[i].taskCount + ")";
              this.nodes_Cases.push(workQueTreeDO)
            }
          }
          this.nodes = this.nodes_Cases;
        }
      }, (errResponse) => {
        console.log(errResponse)
      })
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      // dateString = moment(rawDate).format('DD MMM YYYY HH:mm:ss');
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  getWorkBenchSearchCriteriaList() {
    this.metadataService.fetchAPIMetaData('searchInbox')
      .subscribe(jsonResp => {
        if (jsonResp && Array.isArray(jsonResp)) {
          jsonResp.forEach(criteria => {
            let searchCriteriaDO = new SearchAPIMetaDataDO();
            searchCriteriaDO.key = criteria.attributeName;
            searchCriteriaDO.keyDescription = criteria.description;
            searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            searchCriteriaDO.lookupName = criteria.attributeLookupCd;
            searchCriteriaDO.lookup = [];
            searchCriteriaDO.enable = true;
            searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            this.CRITERIALOOKUP.push(searchCriteriaDO)
          })
        }
      })
  }
  public getFolderData(queueCd): void {
    this.inboxSortService.setSortCondition(queueCd);
  }
  setServerDateToUIDateFormat() {
    if (this.workQueueAPIResponse)
      this.workQueueAPIResponse.forEach(element => {
        element.eventDt = this.getDateString(element.eventDt)
      });
  }

  taskList: any = []
  taskSubject$
  refreshReassingTaskList() {
    if (this.taskSubject$)
      this.taskSubject$.unsubscribe()
    this.taskSubject$ = this.interactService.taskSubject$.subscribe(res => {
      if (res.data) {

        if (event) {
          let indexFound = this.taskList.findIndex(item => {
            if (item.id)
              return item.id === res.data.id;
          })
          if (indexFound === -1) {
            this.taskList.push(res.data)
          }
        }
        else {

          let output = this.taskList.filter(item => {
            if (item.id)
              return item.id !== res.data.id;
          }) || []
          this.taskList = output;
        }
      }
    })
  }
  showAssingModal() {
    if (this.taskList.length == 0)
      this.notification.error('No records selected', 'Please select at least one task');
    else
      this.modShowReassing = true;
  }
  //modShowReassing=false
  assingTo: any;
  assingTask() {

    if (!!!this.assingTo)
      this.notification.error('No data selected', 'Please select at least one user');
    else {
      let listTaskIDs = this.taskList.map(task => task.id)
      this.workQueueService.reassignTaskToUser(listTaskIDs, this.assingTo, this.taskList)
        .subscribe(resp => {
          if (typeof resp.ok === 'undefined') {
            this.modShowReassing = false
            this.notification.success("Task assigned successfully", `The reference numbers reassigned are: ${resp['taskList'] && Array.isArray(resp['taskList']) ? resp['taskList'].map(task => task.claimNum ? task.claimNum : (task.intimationNum ? task.intimationNum : `TaskId: ${task.id}`)) : 'None'}`);
            this.interactService.pingForRefreshWorkbench();
          }
          else {
            this.notification.error("Technical issue occurred, please contact IT Support.", 'Server Error')
          }
        })
    }
  }
}
